var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar4Point(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.01874 2.25H8.64374C8.41874 2.25 8.23124 2.41875 8.23124 2.64375C8.04374 5.2875 5.26875 7.9875 2.625 8.23125C2.41875 8.25 2.25 8.4375 2.25 8.64375V9.0375C2.25 9.2625 2.41875 9.43125 2.64375 9.45C5.26874 9.6375 7.94999 12.3562 8.23124 15C8.24999 15.2437 8.45624 15.4313 8.71874 15.4313H8.98124C9.24374 15.4313 9.44999 15.2438 9.46874 14.9813C9.69374 12.0188 12.075 9.58125 15.0375 9.43125C15.2812 9.4125 15.45 9.225 15.45 8.98125V8.64375C15.45 8.4 15.2625 8.2125 15.0375 8.19375C12.0562 8.04375 9.65624 5.5875 9.46874 2.5875C9.43124 2.41875 9.24374 2.25 9.01874 2.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar4Point);
export default __webpack_public_path__ + "static/media/star-4-point.baf47580bdb71a3fd3ab1cd72d26703f.svg";
export { ForwardRef as ReactComponent };